import React from 'react';
import BrandLogo from './BrandLogo';

/**
 * Displays a vertical step-list sidebar showing wizard progress.
 *
 * @param {number}   currentStep   - Zero-based index of the active step.
 * @param {Array}    steps         - Array of { label, icon, number? } step descriptors
 *                                   (steps without a number show their icon).
 * @param {Set}      hidden        - Indices of steps not shown (e.g. Import with nothing to import).
 * @param {function} onStepClick   - Called with the step index when clicked.
 * @param {Array}    stepStatuses  - Array of 'complete' | 'partial' | 'empty' per step.
 */
export default function ProgressSidebar({ currentStep, steps, hidden = new Set(), onStepClick, stepStatuses = [] }) {
  return (
    <nav className="cashflow-sidebar d-none d-lg-flex flex-column p-3">
      <div className="mb-3 text-center"><BrandLogo size={48} /></div>
      <p className="text-uppercase fw-semibold small text-center mb-3 px-1" style={{ color: '#fff' }}>
        Annual Cashflow Analysis
      </p>

      <ol className="list-unstyled flex-fill cashflow-step-list">
        {steps.map((step, idx) => {
          if (hidden.has(idx)) return null;
          const isActive = idx === currentStep;
          const status = stepStatuses[idx] || 'empty';

          let stateClass = 'cashflow-step--empty';
          if (isActive) {
            stateClass = 'cashflow-step--active';
          } else if (status === 'complete') {
            stateClass = 'cashflow-step--done';
          } else if (status === 'partial') {
            stateClass = 'cashflow-step--partial';
          }

          return (
            <li
              key={idx}
              className={`cashflow-step-item ${stateClass}`}
              onClick={() => onStepClick && onStepClick(idx)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === 'Enter' && onStepClick && onStepClick(idx)
              }
            >
              <span className="cashflow-step-indicator">
                {!isActive && status === 'complete' ? (
                  <i className="bi bi-check-lg" />
                ) : !isActive && status === 'partial' ? (
                  <i className="bi bi-pencil-fill" style={{ fontSize: '0.6rem' }} />
                ) : step.number == null ? (
                  <i className={`bi ${step.icon}`} style={{ fontSize: '0.75rem' }} />
                ) : (
                  <span className="cashflow-step-number">{step.number}</span>
                )}
              </span>
              <span className="cashflow-step-label">{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
